import {OnboardingStatus} from "../../../../utils/enums";
import {CheckOutlined} from '@ant-design/icons';
import {ReactComponent as PencilIcon} from '../../../../assets/svg/pencil.svg';
import {ReactComponent as Info} from '../../../../assets/svg/info.svg';
import {Link} from "react-router-dom";
import React from "react";
import DOMPurify from 'dompurify';
import {Tooltip} from 'antd';
import moment from 'moment';

function buildDefaultColumn(title: string, dataIndex: string, width: string) {
    return {
        title,
        dataIndex,
        key: dataIndex,
        width
    };
}

const OnboardingStatusDisplay: { [key in OnboardingStatus]: string } = {
    [OnboardingStatus.IN_PROGRESS]: 'In Progress',
    [OnboardingStatus.DRAFT]: 'Draft',
    [OnboardingStatus.COMPLETED]: 'Completed',
    [OnboardingStatus.FAILED]: 'Failed'
};

function buildStepsTooltipContent(record: any) {
    const stepsCompletion = record.stepsCompletion.steps.length > 0 ? [...record.stepsCompletion.steps] : [];
    if (record.latestPostgres2SfOemSync) {
        stepsCompletion.push({stepType: 'latest postgres2sf oem sync', lastUpdated: record.latestPostgres2SfOemSync});
    }
    if (record.latestPostgres2SfAccountSync) {
        stepsCompletion.push({
            stepType: 'latest postgres2sf account sync',
            lastUpdated: record.latestPostgres2SfAccountSync
        });
    }
    if (record.latestPostgres2SfApnSync) {
        stepsCompletion.push({stepType: 'latest postgres2sf apn sync', lastUpdated: record.latestPostgres2SfApnSync});
    }
    return (
        <div>
            {stepsCompletion.map(item => (
                <div className='step' key={item.stepType}>
                    <span>{`${item.stepType.toLowerCase().replaceAll('_', ' ')}: `}</span>
                    <span
                        className='last-updated'>{`${item.lastUpdated ? moment(item.lastUpdated).format('YYYY-MM-DD HH:mm:ss') : ''}`}</span>
                </div>
            ))}
        </div>
    );
}

export const getColumns = (): any => [
    {
        title: 'Active?',
        dataIndex: 'isActive',
        key: 'isActive',
        render: (isActive: any) => isActive ? <CheckOutlined/> : null,
        width: '6%'
    },
    {
        title: 'Onboarding status',
        dataIndex: 'status',
        key: 'status',
        render: (status: OnboardingStatus, record: any) =>
            <>
                {status == OnboardingStatus.DRAFT ?
                    <Link className="draft"
                          to={`../customer-edit/${record.name}`}>Draft</Link> : OnboardingStatusDisplay[status]}
                {record.stepsCompletion.steps.length > 0 ?
                    <Tooltip title={buildStepsTooltipContent(record)} placement={"top"}
                             styles={{
                                 body: {width: 520, border: '1px solid white'},
                             }}>
                        <Info className='info-icon'/>
                    </Tooltip> : null}
            </>,
        width: '10%'
    },
    buildDefaultColumn('Customer name', 'label', '10%'),
    buildDefaultColumn('Internal name', 'name', '10%'),
    buildDefaultColumn('Business center name', 'externalName', '10%'),
    buildDefaultColumn('Snowflake name', 'sfName', '10%'),
    buildDefaultColumn('Device location', 'locationType', '7%'),
    buildDefaultColumn('RAT type', 'ratTypeList', '8%'),
    {
        title: 'APNs',
        dataIndex: 'apns',
        key: 'apns',
        render: (apns: string[]) => (
            <>
                {apns?.map((apn) => (
                    <div key={apn} className='apn-item'>{apn}</div>
                ))}
            </>
        ),
        width: '16%',
        ignoreTextAlign: true
    },
    {
        title: 'Settings',
        dataIndex: 'name',
        key: 'settings',
        render: (name: string, record: any) => (record.status == OnboardingStatus.COMPLETED
                && record.isActive) &&
            <Link className="draft" to={`../../${DOMPurify.sanitize(name)}/settings`}>Settings</Link>,
        width: '7%'
    },
    {
        dataIndex: 'name',
        key: 'edit',
        render: (name: string, record: any) => record.status != OnboardingStatus.IN_PROGRESS &&
            <Link className="draft" to={`../customer-edit/${record.name}`}>
                <PencilIcon className='pencil-icon'/>
            </Link>,
        width: '4%'
    }
];